module.exports = __webpack_public_path__ + "img/coding-skills-building.2a315621.svg";